import { Component, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-input-label',
  templateUrl: './input-label.component.html',
  styleUrls: ['./input-label.component.less'],
})
export class InputLabelComponent extends Field {
  editMode = false;
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  changeEditMode(newStatus: boolean): void {
    if (newStatus === true) {
      if (this.recordProperty.ReadOnly) {
        return;
      } else {
        this.editMode = newStatus;
      }
    } else {
      this.editMode = newStatus;
    }
  }

  valueChanged(): void {
    super.valueChanged();
    this.editMode = false;
  }
}
